module.exports = __webpack_public_path__ + "static/media/38.ebd09194.png";